import styled from 'styled-components';

export const Section = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.COLOR.WHITE};
  padding: ${({ isMobile }) => (isMobile ? '12px 24px' : '20px 36px')};
  border-radius: 10px;
  margin-bottom: 30px;
  ${({ theme }) => theme.FONT.B1};
  font-weight: 500;
  white-space: pre-line;

  & .list {
    display: list-item;
    list-style-type: '•';
    padding-inline-start: 8px;
    margin-left: 12px;
    color: ${({ theme }) => theme.COLOR.GREY_01};
  }

  & .order {
    list-style-type: decimal;
  }
`;

export const ParagraphWrapper = styled.div<{ noMargin?: boolean }>`
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ noMargin }) => (noMargin ? '0' : '20px')};
`;

export const SectionTitle = styled.p<{
  isMobile: boolean;
  margin?: string;
}>`
  ${({ isMobile, margin }) =>
    margin
      ? `margin: ${margin}`
      : isMobile
        ? 'margin:20px 0'
        : 'margin: 40px 0'};
  ${({ isMobile, theme }) =>
    isMobile ? theme.NEW_FONT.H3 : theme.NEW_FONT.H2};
  font-weight: 700;
  text-align: center;
`;

export const SectionSubTitle = styled.p<{ bold?: boolean }>`
  min-width: 110px;
  ${({ theme }) => theme.NEW_FONT.H4};
  font-weight: ${({ bold }) => (bold ? 800 : 600)};
  line-height: 27px;
  margin-bottom: 20px;
`;

export const Text = styled.p<{
  color?: string;
  margin?: string;
  fontWeight?: number;
}>`
  width: fit-content;
  ${({ theme }) => theme.FONT.B1};
  font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : 500)};
  word-break: keep-all;
  color: ${({ color, theme }) => (color ? color : `${theme.COLOR.GREY_01}`)};
  margin: ${({ margin }) => (margin ? margin : '0')};
`;

export const ListWrapper = styled.ul<{ color?: string }>`
  display: flex;
  flex-direction: column;
  gap: 2px;
  line-height: 27px;

  & .list {
    ${({ color }) => (color ? `color: ${color}` : '')};
  }
`;

export const OrderListWrapper = styled.ol`
  display: flex;
  flex-direction: column;
  gap: 2px;
  line-height: 27px;
  padding-left: 20px;
`;

export const ColorText = styled.span<{ color: string }>`
  color: ${({ color, theme }) => (color ? color : theme.COLOR.GREY_01)};
`;

export const List = styled.li.attrs({ className: 'list' })<{
  color?: string;
}>`
  ${({ color }) => (color ? `color: ${color}` : '')};
`;

export const OrderList = styled.li.attrs({ className: 'order' })``;
